export function DappLoadingState() {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="relative">
        <div className="size-12 rounded-full border-4 border-neutral-700 border-t-teal-500 animate-spin" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="size-6 bg-neutral-900 rounded-full" />
        </div>
      </div>
    </div>
  );
}
